import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import SolutionDetail from "@/pages/SolutionDetail";

export const Route = createFileRoute("/es/industrias/productos-combinados")({
  head: () => buildRouteHead("/es/industrias/productos-combinados"),
  component: SolutionDetail,
});

